<template>
	<Calendar
		:modelValue="value"
		:inline="true"
		@date-select="onSetDate"
	>
		<template #footer>
			<div class="commitment-calendar__actions">
				<div class="commitment-calendar__action-remove">
					<TeamingButton
						type="TERTIARY"
						size="SMALL"
						@buttonPress="onRemove"
						:destructive="true"
					>
						{{$t("common.CommitmentCalendar__removeButtonLabel" ) }}
					</TeamingButton>
				</div>
				<div class="commitment-calendar__action-cancel">
					<TeamingButton
						type="QUATERNARY"
						size="SMALL"
						@buttonPress="onCancel"
					>
						{{$t("common.CommitmentCalendar__cancelButtonLabel" ) }}
					</TeamingButton>
				</div>
			</div>
		</template>
	</Calendar>
</template>

<script>
import Calendar from "primevue/calendar";
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "CommitmentCalendar",

	components: {
		Calendar,
		TeamingButton,
	},

	props: {
		value: {
			type: Object,
		},
	},

	methods: {
		onRemove() {
			this.$emit( "removeDate" );
		},
		onCancel() {
			this.$emit( "cancel" );
		},
		onSetDate( date ) {
			this.$emit( "setDate", date );
		},
	},
};
</script>

<style lang="scss">
.commitment-calendar__actions {
	display: flex;
}

.commitment-calendar__action-remove {
	text-align: right;
	margin-right: .5rem;
    flex-grow: 1;
}

.commitment-calendar__action-cancel {
	text-align: left;
	margin-left: .5rem;
    flex-grow: 1;
}
</style>
